import { call, put, takeEvery } from 'redux-saga/effects';
import { CheckDpPostAccess, DpNewsFeedActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { dpNewsFeedActionCreators } from '../dpNewsFeedActionCreators';
import { checkDpPostAccess } from '../dpNewsFeedApi';

function* checkDpPostAccessSaga(action: CheckDpPostAccess) {
  yield put(uiActionCreators.toggleLoading('checkDpPostAccess'));
  const response: IApiExecuteRespone<string[]> = yield call(checkDpPostAccess, action.payload.postId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(dpNewsFeedActionCreators.setPostAccess({ postId: action.payload.postId, access: response.value }));
  }

  yield put(uiActionCreators.toggleLoading('checkDpPostAccess'));
}

export function* watchCheckDpPostAccess() {
  yield takeEvery(DpNewsFeedActionKeys.CHECK_DP_POST_ACCESS, checkDpPostAccessSaga);
}
